// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_array from "rescript/lib/es6/caml_array.js";
import * as ReactIntl from "react-intl";
import * as ReactAlert from "react-alert";
import * as Core from "@material-ui/core";
import * as Utils_Api$DvmAdminFrontendFr from "../../common/utils/Utils_Api.bs.js";
import * as App_Spinner$DvmAdminFrontendFr from "../../common/components/App_Spinner.bs.js";
import * as SimpleAlert$DvmAdminFrontendFr from "../../alert/SimpleAlert.bs.js";
import * as Utils_Alert$DvmAdminFrontendFr from "../../common/utils/Utils_Alert.bs.js";
import * as Theme_Colors$DvmAdminFrontendFr from "../../theme/Theme_Colors.bs.js";
import * as User_Context$DvmAdminFrontendFr from "../../context/user/User_Context.bs.js";
import * as App_Typography$DvmAdminFrontendFr from "../../common/App_Typography.bs.js";
import * as App_Table_Result$DvmAdminFrontendFr from "../../common/components/table/App_Table_Result.bs.js";
import * as App_Types_Result$DvmAdminFrontendFr from "../../common/types/App_Types_Result.bs.js";
import * as Pool_Expenses_Api$DvmAdminFrontendFr from "./Pool_Expenses_Api.bs.js";
import * as Pool_Expenses_Table$DvmAdminFrontendFr from "./Pool_Expenses_Table.bs.js";
import * as App_Table_Pagination$DvmAdminFrontendFr from "../../common/components/table/App_Table_Pagination.bs.js";
import * as Pool_Expenses_Filter$DvmAdminFrontendFr from "./Pool_Expenses_Filter.bs.js";
import * as Messages_Pool_Expenses$DvmAdminFrontendFr from "../../intl/messages/poolExpenses/Messages_Pool_Expenses.bs.js";

function Pool_Expenses_Page(Props) {
  var operation = Props.operation;
  var match = Curry._1(User_Context$DvmAdminFrontendFr.Context.useAppContext, undefined);
  var match$1 = match[0];
  var userManager = match$1.userManager;
  var selectedRole = match$1.selectedRole;
  var intl = ReactIntl.useIntl();
  var match$2 = React.useState(function () {
        return /* NotStarted */0;
      });
  var setTablePage = match$2[1];
  var tablePage = match$2[0];
  var match$3 = React.useState(function () {
        if (selectedRole === /* RMPC */9 || selectedRole === /* MRR */8) {
          return /* MR */1;
        } else {
          return /* RMPC */0;
        }
      });
  var setTableType = match$3[1];
  var tableType = match$3[0];
  var match$4 = React.useState(function () {
        return {
                page: 0,
                rowsPerPage: Caml_array.get(App_Table_Pagination$DvmAdminFrontendFr.options, 0),
                headers: Pool_Expenses_Table$DvmAdminFrontendFr.headersConfiguration(tableType, selectedRole),
                filterQueryParams: "",
                additionalQueryParams: /* [] */0
              };
      });
  var setFetchRequest = match$4[1];
  var fetchRequest = match$4[0];
  var alert = ReactAlert.useAlert();
  var fetchData = function (submissionCallbacks, fetchRequest) {
    Pool_Expenses_Api$DvmAdminFrontendFr.fetchPoolExpenses(submissionCallbacks, userManager, setTablePage, Utils_Api$DvmAdminFrontendFr.createQueryParams(undefined, fetchRequest), selectedRole, tableType);
    Curry._1(setFetchRequest, (function (param) {
            return fetchRequest;
          }));
  };
  React.useEffect((function () {
          App_Types_Result$DvmAdminFrontendFr.forError(tablePage, (function (error) {
                  Utils_Alert$DvmAdminFrontendFr.error(undefined, alert, React.createElement(SimpleAlert$DvmAdminFrontendFr.make, {
                            message: {
                              TAG: /* RestError */2,
                              _0: error
                            }
                          }));
                }));
        }), [tablePage]);
  var tmp;
  tmp = typeof tablePage === "number" ? (
      tablePage === /* NotStarted */0 ? null : React.createElement(App_Spinner$DvmAdminFrontendFr.make, {})
    ) : (
      tablePage.TAG === /* Ok */0 ? React.createElement(App_Table_Result$DvmAdminFrontendFr.make, {
              number: tablePage._0.total,
              message: Messages_Pool_Expenses$DvmAdminFrontendFr.resultInfo
            }) : null
    );
  return React.createElement(React.Fragment, undefined, React.createElement(App_Typography$DvmAdminFrontendFr.make, {
                  style: {
                    fontWeight: "600"
                  },
                  children: intl.formatMessage(Messages_Pool_Expenses$DvmAdminFrontendFr.title),
                  variant: "h3"
                }), React.createElement(Pool_Expenses_Filter$DvmAdminFrontendFr.make, {
                  fetchData: fetchData,
                  fetchRequest: fetchRequest,
                  tableType: tableType
                }), selectedRole === /* RMPC */9 || selectedRole === /* MRR */8 ? null : React.createElement(Core.Grid, {
                    children: null,
                    container: true,
                    spacing: 2
                  }, React.createElement(Core.Grid, {
                        children: React.createElement(Core.Button, {
                              onClick: (function (param) {
                                  Curry._1(setTableType, (function (param) {
                                          return /* RMPC */0;
                                        }));
                                }),
                              style: tableType ? ({}) : ({
                                    borderBottom: "solid 5px " + Theme_Colors$DvmAdminFrontendFr.primaryBrown + ""
                                  }),
                              children: intl.formatMessage(Messages_Pool_Expenses$DvmAdminFrontendFr.expensesRMPC)
                            }),
                        item: true
                      }), React.createElement(Core.Grid, {
                        children: React.createElement(Core.Button, {
                              onClick: (function (param) {
                                  Curry._1(setTableType, (function (param) {
                                          return /* MR */1;
                                        }));
                                }),
                              style: tableType ? ({
                                    borderBottom: "solid 5px " + Theme_Colors$DvmAdminFrontendFr.primaryBrown + ""
                                  }) : ({}),
                              children: intl.formatMessage(Messages_Pool_Expenses$DvmAdminFrontendFr.expensesMR)
                            }),
                        item: true
                      })), React.createElement(Core.Box, {
                  children: null
                }, tmp, React.createElement(Pool_Expenses_Table$DvmAdminFrontendFr.make, {
                      tablePage: tablePage,
                      fetchRequest: fetchRequest,
                      fetchData: fetchData,
                      operation: operation,
                      tableType: tableType
                    })));
}

var Api;

var Table;

var Filter;

var make = Pool_Expenses_Page;

export {
  Api ,
  Table ,
  Filter ,
  make ,
}
/* react Not a pure module */
